import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

type Props = {
  open: boolean;
  message?: string;
  zIndex?: number;
};

const SubmittingFormBackdrop: React.FC<Props> = ({ open, message = "Saving...", zIndex }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => (typeof zIndex === "number" ? zIndex : theme.zIndex.modal + 10),
        color: "rgba(0,0,0,0.87)",
        backdropFilter: "blur(2px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          bgcolor: "#fff",
          px: 3,
          py: 2,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          gap: 2,
          boxShadow: "0px 8px 32px rgba(16,24,40,0.18)",
        }}
      >
        <CircularProgress size={24} />
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default SubmittingFormBackdrop;
